import { ReturnComponent } from '@/utils/reactTypes';
import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { useMemo } from 'react';

// Reads as a tag rather than a second chip when it sits inside one.
const INACTIVE_TAG_FONT_SIZE = '0.625rem';
const INACTIVE_TAG_WEIGHT = 600;

type ClinicianInactiveTagProps = Omit<BoxProps, 'children'>;

// Marks a clinician who is no longer active, alongside their name.
export const ClinicianInactiveTag = ({
    sx: providedSx,
    ...rest
}: ClinicianInactiveTagProps): ReturnComponent => {
    const sx = useMemo(
        (): SxProps<Theme> => ({
            ml: 0.75,
            px: 0.5,
            py: 0.125,
            borderRadius: 0.5,
            backgroundColor: 'action.selected',
            color: 'text.secondary',
            fontSize: INACTIVE_TAG_FONT_SIZE,
            fontWeight: INACTIVE_TAG_WEIGHT,
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
            ...providedSx,
        }),
        [providedSx],
    );

    return (
        <Box component='span' sx={sx} {...rest}>
            INACTIVE
        </Box>
    );
};
